/* eslint-disable */
require('script-loader!file-saver')


function s2ab(s) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}


export function export_json_to_excel({
  multiHeader = [],
  header,
  data,
  filename = 'excel-list',
  merges = [],
  styles = [],
  autoWidth = true,
  bookType=  'xlsx'
} = {}) {

  return export_json_to_excel_lusis({
    multiHeader,
    header,
    data,
    filename,
    merges,
    styles,
    autoWidth,
    bookType
  })
}


export function export_json_to_excel_lusis({
  multiHeader = [],
  header,
  data,
  filename = 'excel-list',
  sheetName = 'Sheet 1',
  merges = [],
  styles = [],
  autoWidth = true,
  bookType = 'xlsx'
} = {}) {

  let sheetList = [{
    header,
    multiHeader,
    data,
    sheetName,
    merges,
    styles
  }]

  return export_json_to_excel_lusis_multisheet({
    filename: filename,
    autoWidth: autoWidth,
    bookType: bookType,
    sheets: sheetList
  })
}


export function export_json_to_excel_lusis_multisheet({
  sheets = [
    {
      header: [],
      multiHeader: [],
      data: [],
      sheetName: 'Sheet 1',
      merges: [],
      styles: []
    }
  ],
  filename = 'excel-list',
  autoWidth = true,
  bookType = 'xlsx'
} = {}) {

  const Excel = require('exceljs')
  var wb = new Excel.Workbook()
  
  if (sheets && sheets.length) {
    sheets.forEach(sheet => {
      const ws = wb.addWorksheet(sheet.sheetName)
  
      let data = [...sheet.data]
      if (sheet.header) data.unshift(sheet.header)
  
      if (sheet.multiHeader && sheet.multiHeader.length) {
        for (let i = sheet.multiHeader.length - 1; i > -1; i--) {
          data.unshift(sheet.multiHeader[i])
        }
      }
  
      ws.addRows(data)

      let columns = []
      for (let c = 1; c < ws.columnCount + 1; c++) {
        columns.push({ width: 10 })
      }
      ws.columns = columns

      //styles
      // styles: {
      //   type: 'row' / 'column' / 'cell'
      //   key: rowNumber / columnNumber / [rowNumber,columnNumber]
      //   value: { bold: true, fill: "cccccc" }, //xlsx-populate
      //   propValue: { "font":{ bold: true }, "fill": {type: 'pattern', pattern: 'solid', fgColor: {argb: 'cccccc'}} } //exceljs
      // })
      if (sheet.styles && sheet.styles.length) {
        sheet.styles.forEach(style => {
          let obj = {}
          if (style.type==='row') {
            obj = ws.getRow(style.key)
          } else if (style.type==='column') {
            obj = ws.getColumn(style.key)
          } else if (style.type==='cell') {
            let row = ws.getRow(style.key[0])
            if (row) {
              obj = row.getCell(style.key[1])
            }
          }

          if (obj) {
            let propValue = style.propValue
            if (propValue && typeof propValue === 'object') {
              for (let prop of Object.keys(propValue)) {
                obj[prop] = propValue[prop]
              }
            }
          }
        })
      }

      //merges
      if (sheet.merges && sheet.merges.length) {
        sheet.merges.forEach(merge => {
          ws.mergeCells(merge)
        })
      }
  
      if (autoWidth) {
        let max = 0
        const colWidth = data.map(row => row.map(val => {
          if (val == null) {
            return max
          } else {
            return Math.max(max,val.toString().length)
          }
        }))
        let result = colWidth[0]
        for (let i = 1; i < colWidth.length; i++) {
          for (let j = 0; j < colWidth[i].length; j++) {
            if (result[j] < colWidth[i][j]) {
              result[j] = colWidth[i][j]
            }
          }
        }

        for (let c = 0; c < result.length; c++) {
          let col = ws.getColumn(c+1)
          if (col) {
            col.width = result[c] * 2
          }
        }
      }
    })
  }

  wb.xlsx.writeBuffer().then(data => {
    saveAs(new Blob([data], {
      type: "application/octet-stream"
    }), `${filename}.${bookType}`)
   })
}
